const initialState = {
  user: {},
  flash: {},
  activity: {},
  socket: null,
};

export default initialState;